export default {
    title: "Игра ДЕДЛАЙН",
    rules: "Правила игры",
    lines: [
        "Уничтожь баги, обходи нервных сотрудников и собирай код, чтобы закончить проекты. Печенько в помощь !",
        "Нужно выполнить максимальное количество проектов пока вас не накроет дедлайн",
        "Управляйте персонажем `влево`, `вправо`, `вверх` (стрелочками) и `ЛКМ/Пробел` (удар)",
    ],
    bestResult: "Лучший результат",
    time: "Время",
    project: "Проекты"
}